<script>
    import { text } from "svelte/internal";



export let x, y, gridlinesParametersArray, fontSize = "14px", textAnchorSplit = false;


gridlinesParametersArray.forEach((e,i) => {

    e["textAnchor"] = "middle"

    if (textAnchorSplit) {

        if (i == 0) {e["textAnchor"] = "end"}
        else if (i == gridlinesParametersArray.length-1) {e["textAnchor"] = "start"}
    }
});

</script>


<g class="x-gridlines">

    {#each gridlinesParametersArray as d, i}

        <text
        y=-6
        x={x(d["value"])+{middle: 0, start: -5, end: 5}[d["textAnchor"]]}
        stroke="none"
        fill="#333"
        font-size={fontSize}
        text-anchor={d["textAnchor"]}
        opacity={d["opacity"]*3} 
        >{d["value"]}</text>

        <!-- svelte-ignore component-name-lowercase -->
        <line
        x1={x(d["value"])}
        x2={x(d["value"])}
        y1=0
        y2={y}
        stroke="#333"
        opacity={d["opacity"]}
        ></line>

    {/each}

</g>